<template>
  <component :is="label || icon ? 'label' : 'div'" class="flex items-center gap-1">
    <SMIcon v-if="icon" :icon="icon" />
    <span v-if="label">{{ label }}</span>
    <input
      type="color"
      class="p-0 border-none grow self-stretch"
      :model-value="modelValue"
      @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    />
  </component>
</template>

<script setup lang="ts">
import SMIcon from './SMIcon.vue';

const props = defineProps<{
  modelValue: string;
  icon?: string;
  label?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', color: string): void;
}>();
</script>

<style scoped>
input::-webkit-color-swatch-wrapper {
  padding: 0;
}
</style>
